import axios from 'axios';
import { constants } from '../Utils/constants';
import { setServerBaseUrl } from '../Utils/setServerBaseUrl';
import ReactGA from 'react-ga';
import { useState, useEffect } from 'react';

export const useApi = () => {
  const apiBaseUrl = setServerBaseUrl();
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/utils/get-currencies`, {
          mode: 'cors',
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
        });
        if (response && response.data) {
          setCurrencies(response.data);
        }
      } catch (error) {
        console.error('Error fetching currencies:', error);
        setCurrencies([]);
      }
    };
    fetchCurrencies();
  }, [apiBaseUrl]);
  const mitigationUrl = `${apiBaseUrl}${constants.BE_ENDPOINTS.VERIFY_AUTHORIZE}`;
  const showOfferBaseUrl = `${apiBaseUrl}${constants.BE_ENDPOINTS.SHOW_OFFER}`;
  const getCreditBaseUrl = `${apiBaseUrl}${constants.BE_ENDPOINTS.GET_CREDIT}`;
  const postEventUrl = `${apiBaseUrl}${constants.BE_ENDPOINTS.POST_EVENT}`;
  const fetchLocalizedDataByLanguageUrl = `${apiBaseUrl}${constants.BE_ENDPOINTS.FETCH_LOCALIZED_DATA}`;

  async function verifyOrAuthorizePspToken(reqBody) {
    try {
      const resp = await axios.post(mitigationUrl, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
        ...reqBody,
      });
      if (resp) {
        return resp;
      }
    } catch (error) {
      return error;
    }
  }

  async function fetchLocalizedDataByLanguage(language, type) {
    try {
      const resp = await axios.get(`${fetchLocalizedDataByLanguageUrl}?language=${language}&type=${type}`, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });
      if (resp) {
        return resp.data;
      }
    } catch (error) {
      return error;
    }
  }

  async function postEvent(reqBody) {
    try {
      const resp = await axios.post(postEventUrl, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
        ...reqBody,
      });
      if (resp) {
        return resp;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchOffer(token) {
    try {
      const resp = await axios.get(`${showOfferBaseUrl}?id=${token}`, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });
      if (resp) {
        ReactGA.event({
          category: 'NayaxCapital',
          action: 'Option_Displayed',
          // value: 555,
        });
        return resp;
      }
    } catch (error) {
      ReactGA.exception({
        description: `An error occured on Nayax Capital offer page`,
        fatal: true, //do we want to document this?
      });
      return error;
    }
  }

  async function getCustomerCredit(queryParam) {
    try {
      const resp = await axios.get(`${getCreditBaseUrl}?id=${queryParam}`, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });
      if (resp) {
        console.log('resp:', resp);
      }
      return resp;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return {
    verifyOrAuthorizePspToken,
    fetchOffer,
    getCustomerCredit,
    postEvent,
    fetchLocalizedDataByLanguage,
    currencies,
  };
};
